import { widont } from 'utils/typography';
import { DefaultBlockProps } from '../switchBlock/SwitchBlock';
import style from './QuoteBlock.module.scss';

export type BlockQuoteType = DefaultBlockProps & {
  block_type: 'quote';
  text: string;
  attribution_person: string;
  attribution_position: string;
};

export const QuoteBlock = (props: BlockQuoteType): JSX.Element | null => {
  // https://css-tricks.com/snippets/javascript/strip-html-tags-in-javascript/
  // const strippedString = props.text.replace(/(<([^>]+)>)/gi, '');
  const classBasedOnCharLength = null; //strippedString.length > 70 ? style.textLongQuote : null;
  return (
    <div className={`${style.container}  block-quote`}>
      <blockquote
        className={`${style.text} ${classBasedOnCharLength} block-quote-element`}
        dangerouslySetInnerHTML={{ __html: widont(props.text) }}
      />
      {/* <blockquote className={`${style.text} `} dangerouslySetInnerHTML={{ __html: props.text }} /> */}
      <span className="block-quote-credit">
        {props.attribution_person && (
          <span className={`${style.credit} `} dangerouslySetInnerHTML={{ __html: ` — ${props.attribution_person}`}} />
        )}
        {props.attribution_position && (
          <span className={`${style.position} `} dangerouslySetInnerHTML={{ __html: ` — ${props.attribution_position}`}} />
        )}
      </span>
    </div>
  );
};
